import { getLocale } from '../../utils/i18n';
import { AmsDashboardMFE } from './AmsDashboardMFE';
import { AmsAuthErrorBoundary } from './AmsAuthErrorBoundary';

const AMS_DASHBOARD_CATEGORY = 'strength_dashboard';

export const ReportingPage = () => {
  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        width: '100%',
        height: '100%',
        padding: '16px',
      }}
    >
      <AmsAuthErrorBoundary>
        <AmsDashboardMFE
          category={AMS_DASHBOARD_CATEGORY}
          locale={getLocale()}
        />
      </AmsAuthErrorBoundary>
    </div>
  );
};
